export const inspectTable_1 = [
  {
    id: 1,
    label: "시설물 주변의 지반 침하 또는 이로 인한 건물의 기움, 균열 등",
    is_checked: "",
    title: "1) 지반상태",
    titleColor: "#F9F9F9",
  },
  {
    id: 2,
    label: "주요 구조부재(보, 기둥, 슬래브, 내력벽)에 균열, 누수 및 누수흔적",
    is_checked: "",
    title: "2) 구조부재",
    titleColor: "#F9F9F9",
  },
  {
    id: 3,
    label: "구조부재의 처짐, 기욺 또는 단면 손실 등의 변형",
    is_checked: "",
    title: "2) 구조부재",
    titleColor: "#F9F9F9",
  },
  {
    id: 4,
    label: "철근 부식, 노출 또는 콘크리트의 박리·박락",
    is_checked: "",
    title: "2) 구조부재",
    titleColor: "#F9F9F9",
  },
  {
    id: 5,
    label: "철골부재의 기욺, 좌굴 등의 변형",
    is_checked: "",
    title: "2) 구조부재",
    titleColor: "#F9F9F9",
  },
  {
    id: 6,
    label: "철골부재 부식에 의한 단면 결손",
    is_checked: "",
    title: "2) 구조부재",
    titleColor: "#F9F9F9",
  },
  {
    id: 7,
    label: "내부 칸막이벽(벽돌, 블록 등)에 균열 및 변형(기욺)",
    is_checked: "",
    title: "3) 비구조부재",
    titleColor: "#F9F9F9",
    group: "내부"
  },
  {
    id: 8,
    label: "천장, 벽체 및 바닥 마감재에 파손, 오염, 변형(처짐, 기욺 등), 누수 및 누수흔적",
    is_checked: "",
    title: "3) 비구조부재",
    titleColor: "#F9F9F9",
    group: "내부"
  },
  {
    id: 9,
    label: "옥상, 지붕 방수층의 상태",
    is_checked: "",
    title: "3) 비구조부재",
    titleColor: "#F9F9F9",
    group: "외부"
  },
  {
    id: 10,
    label: "클램쉘 등으로 굴착 토사 운반 시 신호수를 배치하고 하부에 작업자가 출입하지 않토록 통제한다.",
    is_checked: "",
  },
  {
    id: 11,
    label: "트렌치 굴착 시에는 작업 여건, 위험도 등에 따라 간이 흙막이를 설치하거나 굴착면의 안전 기울기를 확보하여야 한다.",
    is_checked: "",
  },
];
export const inspectTable_2 = [
  {
    id: 1,
    label: "거푸집동바리 구조 검토를 실시하고 조립도를 작성하여야 한다. ",
    is_checked: "",
  },
  {
    id: 2,
    label: "거푸집동바리 조립도(동바리, 수평연결재, 가새재 위치 등)에 따라  조립하여야 한다.",
    is_checked: "",
  },
  {
    id: 3,
    label: "거푸집·동바리 조립 시 상부에 자재 과적으로 인한 붕괴위험이 없도록  조치한다. ",
    is_checked: "",
  },
  {
    id: 4,
    label: "작업자에게 적정한 개인보호구(안전모, 안전대 등)를 지급하고  추락 등 위험 시 반드시 안전대를 걸고 작업하여야 한다. ",
    is_checked: "",
  },
  {
    id: 5,
    label: "거푸집 설치-해체-인양작업 시 안전조치 사항에 대해 작업자가 충분히  숙지하도록 특별안전교육을 실시한다.",
    is_checked: "",
  },
  {
    id: 6,
    label: "슬래브 단부, 개구부 등의 추락방호조치는 적절하게 실시하여야 한다.",
    is_checked: "",
  },
  {
    id: 7,
    label: "철근조립 등 고소 작업을 위한 작업발판은 작업장소·위치 등을 고려하여  적정하게 사용하여야 한다. ",
    is_checked: "",
  },
  {
    id: 8,
    label: "고소작업대 사용 시 발 스위치 연동장치, 조작레버 덮개 등의 안전장치 설치와 장비제원, 운전원 실명 등을 부착·관리한다.",
    is_checked: "",
  },
  {
    id: 9,
    label: "콘크리트 펌프카는 아웃트리거를 최대한 인출하고 작업계획서에 따라 관계자외 출입금지, 타설순서 등을 준수하여야 한다.",
    is_checked: "",
  },
  {
    id: 10,
    label: "클램쉘 등으로 콘크리트 양생(갈탄, 열풍기 보온양생) 시 산소·유해가스농도를 수시로 측정하고 출입자는 호흡용 보호구를 반드시 착용한다.굴착 토사 운반 시 신호수를 배치하고 하부에 작업자가출입하지 않토록 통제한다.",
    is_checked: "",
  },
];
export const inspectTable_3 = [
  {
    id: 1,
    label: "자재(벽돌, 블록, 시멘트, 모래, 물 등)는 작업에 필요한 수량만큼 수시로 안전하게 운반하여 사용한다. ",
    is_checked: "",
  },
  {
    id: 2,
    label: "자재 운반 시 다른 작업에 방해되지 않도록 충분한 공간을 확보하고  운반용기계·기구 필요 시 안전성을 검토하여 사용하여야 한다.",
    is_checked: "",
  },
  {
    id: 3,
    label: "내부 마감공사용 이동식비계, 말비계 등의 작업발판은 충분한 안전성을  확보하도록 설치하고 필요한 안전조치를 한다.",
    is_checked: "",
  },
  {
    id: 4,
    label: "작업장 주변과 근로자 이동통로 상의 개구부에는 방호조치 및 안전표지를 부착하여야 한다.",
    is_checked: "",
  },
  {
    id: 5,
    label: "작업자에게 적절한 개인보호구를 지급하고 올바르게 착용하도록 하여야 한다.",
    is_checked: "",
  },
  {
    id: 6,
    label: "작업 장소로 이동하기 위한 안전한 통로를 확보하여야 한다.",
    is_checked: "",
  },
  {
    id: 7,
    label: "천장 마감재 상부 에어컨 설치 등의 작업은 마감재 설치 전에 완료하고 마감재위로 작업자가 올라가지 않도록 한다.",
    is_checked: "",
  },
  {
    id: 8,
    label: "정화조, 저수조 등 밀폐된 공간 내에서 방수 작업 시 질식위험을 제거하여야 한다.",
    is_checked: "",
  },
  {
    id: 9,
    label: "벽체·천장 작업용 내부 비계 설치 시에는 사전에 조립도를 작성하고 필요한 안전조치 및 작업자 이동통로를 확보한다.",
    is_checked: "",
  },
  {
    id: 10,
    label: "방수제 등 사용하는 화학물질에 대한 경고표시를 부착하고, 각 물질에 대한 MSDS를 작업자에게 교육한다.",
    is_checked: "",
  },
];
export const inspectTable_4 = [
  {
    id: 1,
    label: "외부비계 상 벽돌 등 자재는 필요한 수량만큼 적재하여 비계기둥 간의 적재하중은 400kg을 초과하지 않도록 한다.",
    is_checked: "",
  },
  {
    id: 2,
    label: "외부 비계 상 근로자 승강통로는 작업자가 이용하기 쉽도록 충분한 수량을 설치하여야 한다.",
    is_checked: "",
  },
  {
    id: 3,
    label: "외벽과 비계 사이에는 높이 10미터 이내마다 추락방호망을 설치하고 작업에 간섭이 되지 않는 한 안전시설을 해체하지 않는다. ",
    is_checked: "",
  },
  {
    id: 4,
    label: "단열재 등 가연성 물질 주변에서 용접 작업 시 불티 비산방지 등 화재예방조치를 반드시 하여야 한다.",
    is_checked: "",
  },
  {
    id: 5,
    label: "달비계 작업 전 로프 등 자재를 점검하고 달비계 로프 설치 시 작업자가 안전대를 부착하도록 관리감독을 확실히 한다. ",
    is_checked: "",
  },
  {
    id: 6,
    label: "달비계 작업용 섬유로프 및 구명줄은 절단·마모 보호를 위해 보호덮개를  설치해야하며, 견고한 고정점에 결속하여야 한다.",
    is_checked: "",
  },
  {
    id: 7,
    label: "석재 운반용 윈치 사용 시 고정부위가 안전한지 검토하고 줄걸이 방법 등을사전에 확인하여 안전하게 작업하여야 한다.",
    is_checked: "",
  },
  {
    id: 8,
    label: "외부마감 작업 장소로 작업자가 안전하게 이동하기 위한 통로를 확보하여야 한다.",
    is_checked: "",
  },
  {
    id: 9,
    label: "비계 조립 작업 시 주변에 특고압 전선 유무를 사전 확인하여 안전한 작업방법을 검토하고 벽이음 등을 간격에 맞춰 설치한다.",
    is_checked: "",
  },
  {
    id: 10,
    label: "차량탑재형 고소작업대 사용 시 아웃트리거를 최대한 인출하고 탑승자는반드시 안전대를 부착한다.",
    is_checked: "",
  },
];
export const inspectTable_5 = [
  {
    id: 1,
    label: "강도가 약해 깨지기 쉬운 지붕 위에서 작업 시 반드시 30센티미터 이상의  작업발판을 설치해야 한다. ",
    is_checked: "",
  },
  {
    id: 2,
    label: "채광창이 있는 경우 견고한 덮개를 설치해야 한다. ",
    is_checked: "",
  },
  {
    id: 3,
    label: "지붕 가장자리에는 안전난간을 설치해야 하며, 곤란한 경우 추락 방호망을 설치하거나 안전대를 착용해야 한다. ",
    is_checked: "",
  },
  {
    id: 4,
    label: "지붕의 형태, 구조 등을 사전 파악하여 적절한 이동통로, 작업발판설치 등  추락방지 조치를 하여야 한다.",
    is_checked: "",
  },
  {
    id: 5,
    label: "지붕진입을 위한 승강설비(고정식 사다리, 워킹타워 등)를 적정하게 설치한다.",
    is_checked: "",
  },
  {
    id: 6,
    label: "지붕 위에 자재를 집중 또는 과적하지 않도록 한다.",
    is_checked: "",
  },
  {
    id: 7,
    label: "슬레이트, 채광창(skyligt) 지붕의 노후상태를 확인하고, 취약한 지붕재(슬레이트, 채광창 등)에 적절한 추락방호조치(발판, 안전덮개, 추락방지망, 안전대 착용 등 안전조치)를 하여야 한다.",
    is_checked: "",
  },
  {
    id: 8,
    label: "지붕 단부에 추락방호조치(안전난간, 추락방지망, 안전대 착용 등 안전조치)를 하여야 한다. ",
    is_checked: "",
  },
  {
    id: 9,
    label: "지붕 위 작업 시 가공전선에 접촉위험이 없도록 한다. ",
    is_checked: "",
  },
  {
    id: 10,
    label: "작업 전 기상 및 지붕표면 상태를 확인하여 전도위험 등이 있는 경우 작업을 중지한다. ",
    is_checked: "",
  },
];
